import React from 'react';
import { Container } from './styles';

interface CardNewsProps {
  modal: string;
  img: string;
  onClick: (modal: string) => void;
  new_badge: boolean;
}

const CardNews: React.FC<CardNewsProps> = ({ modal, img, onClick, new_badge }) => {
  return (
    <>
      {new_badge && <div className="badge-novidade">NOVIDADE</div>}
      <Container onClick={() => onClick(modal)}>
        <img src={img} alt="" className="card-news-image" />
      </Container>
    </>
  );
};

export default CardNews;
